"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/BMFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_29)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_29`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-8.16003 0H27.84V24H-8.16003V0Z",
					fill: "#C8102E"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-8.16003 0.00701904H9.83997V12.007H-8.16003V0.00701904Z",
					fill: "#012169"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.80488 0H8.21891L3.06804 3.43158V0H-1.42319V3.43158L-6.57407 0H-8.16003V1.59298L-4.92495 3.74737H-8.16003V8.2386H-4.92495L-8.16003 10.393V11.9789H-6.57407L-1.42319 8.54737V11.9789H3.06804V8.54737L8.21891 11.9789H9.80488V10.393L6.56979 8.2386H9.80488V3.74737H6.56979L9.80488 1.59298V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M1.94523 0H-0.300385V4.87018H-8.16003V7.11579H-0.300385V11.9789H1.94523V7.11579H9.80488V4.87018H1.94523V0Z",
					fill: "#C8102E"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-8.16003 11.9789V11.207L-3.77407 8.2386H-2.1881L-7.64775 11.9789H-8.16003ZM-7.64775 0.00701904L-2.1881 3.74035H-3.77407L-8.16003 0.778949V0.00701904H-7.64775ZM9.80488 0.00701904V0.778949L5.41891 3.74737H3.83295L9.2926 0.00701904H9.80488ZM9.2926 11.9789L3.83295 8.2386H5.41891L9.80488 11.207V11.9789H9.2926Z",
					fill: "#C8102E"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.0785 7.01334V14.0091C14.0785 18.2063 19.675 21.0049 19.675 21.0049C19.675 21.0049 25.2715 18.2063 25.2715 14.0091V7.01334H14.0785Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M23.3746 18.2063H15.9753C17.5985 19.9663 19.675 21.0049 19.675 21.0049C19.675 21.0049 21.7515 19.9663 23.3746 18.2063Z",
					fill: "#2F8F22"
				}),
				/* @__PURE__ */ n("path", {
					d: "M19.6749 18.2063C21.2206 18.2063 22.4735 16.9534 22.4735 15.4077C22.4735 13.8621 21.2206 12.6091 19.6749 12.6091C18.1293 12.6091 16.8763 13.8621 16.8763 15.4077C16.8763 16.9534 18.1293 18.2063 19.6749 18.2063Z",
					fill: "#65B5D2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.8763 15.4084C17.6492 15.4084 18.2756 14.7819 18.2756 14.0091C18.2756 13.2363 17.6492 12.6098 16.8763 12.6098C16.1035 12.6098 15.4771 13.2363 15.4771 14.0091C15.4771 14.7819 16.1035 15.4084 16.8763 15.4084Z",
					fill: "#C8102E"
				}),
				/* @__PURE__ */ n("path", {
					d: "M22.4729 15.4084C23.2457 15.4084 23.8722 14.7819 23.8722 14.0091C23.8722 13.2363 23.2457 12.6098 22.4729 12.6098C21.7001 12.6098 21.0736 13.2363 21.0736 14.0091C21.0736 14.7819 21.7001 15.4084 22.4729 15.4084Z",
					fill: "#C8102E"
				}),
				/* @__PURE__ */ n("path", {
					d: "M19.6751 12.6098C20.4479 12.6098 21.0744 11.9833 21.0744 11.2105C21.0744 10.4377 20.4479 9.81122 19.6751 9.81122C18.9022 9.81122 18.2758 10.4377 18.2758 11.2105C18.2758 11.9833 18.9022 12.6098 19.6751 12.6098Z",
					fill: "#C8102E"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_29`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as BMFlag };
